import { render } from "./FooterInfo.vue?vue&type=template&id=986d574a&scoped=true&ts=true"
import script from "./FooterInfo.vue?vue&type=script&lang=ts"
export * from "./FooterInfo.vue?vue&type=script&lang=ts"

import "./FooterInfo.vue?vue&type=style&index=0&id=986d574a&lang=scss&scoped=true"

import exportComponent from "G:\\Runze\\rzhy_main_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-986d574a"]])

export default __exports__